import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PropertyManagementV3ControllerService } from '@booking/angular-booking-user-data-service';
import { WarningService } from '@modules/ota/hotel-ota/services/warning.service';
import { TIME_OUT_REQUEST } from '@shared/constant';
import { Subject, takeUntil, timeout } from 'rxjs';

@Component({
  selector: 'app-ota-warning',
  templateUrl: './ota-warning.component.html',
  styleUrls: ['./ota-warning.component.scss']
})
export class OtaWarningComponent {
    @Input() showContractWarning: boolean
    @Input() isShowBtnUpdateContract: boolean
    isShowContractWarning: boolean = false;
    countReGetContractWarning = 0;
    propertyId: string = '';
    propertyName: string = '';
    cancelSearch$: Subject<void> = new Subject();

    constructor(
      private warningService: WarningService,
      private propertyManagementV3ControllerService: PropertyManagementV3ControllerService,
      private route: ActivatedRoute,
      private router: Router,
    ) {

    }

    ngOnInit(){
      this.route.queryParams.subscribe((params: Params) => {
        this.propertyId = params['property_id'];
        this.propertyName = params['property_name'];
      });
      if(this.showContractWarning){
        this.getContractWarning();
      }
    }

    ngOnChanges(changes: SimpleChanges): void {
      if (changes['showContractWarning'] && this.showContractWarning) {
        this.getContractWarning();
      }
    }

    ngOnDestroy(): void {
      this.cancelSearch$.next();
      this.cancelSearch$.complete();
    }

    navigateContactPage() {
      this.router.navigate([`/ota/hotel-ota/hotel-management/${encodeURIComponent(this.propertyName)}/settings/contract-agreement`], {
        queryParams: {
          property_id: this.propertyId,
          property_name: encodeURIComponent(this.propertyName),
        },
      });   
    }

    getContractWarning() {
      this.warningService.getContractWarning().subscribe((value) => {
        if (value == true) {
          this.isShowContractWarning = value;
        } else if ( value == false ) {
          this.isShowContractWarning = value;
        } else if (value == null) {
          if (this.countReGetContractWarning < 10) {
            this.callGetContractInfo();
            this.countReGetContractWarning++;
          }
  
          if (this.countReGetContractWarning < 10) {
            setTimeout(() => {
              this.getContractWarning();
            }, 3000);
          }
        }
      });
    }

    callGetContractInfo() {
      this.cancelSearch$ = new Subject<void>();
      if(this.propertyId) {
        this.propertyManagementV3ControllerService.getContractInfoByPropertyIdV3(
          this.propertyId
        ).pipe(
            takeUntil(this.cancelSearch$),
            timeout(TIME_OUT_REQUEST),
          )
          .subscribe((response: any) => {
            if (response) {
              if (response.success && response.data) {
                this.isShowContractWarning = !response?.data?.is_update_certificate;
                this.warningService.setContractWarning(this.isShowContractWarning);
              }
            }
          });
      }
    }
}
